import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";

export const PrivacyDialog = ({ children, fields }) => {
  const dataFields =
    fields || "nome, email, telefono, città ed eventuali informazioni nel campo messaggio";
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        className="max-w-lg max-h-[80vh] overflow-y-auto bg-crema border-espresso/15"
        data-testid="privacy-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-espresso">
            Privacy Policy
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm leading-relaxed text-stone mt-2">
          <p>
            Informativa ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs.
            196/2003 come modificato dal D.Lgs. 101/2018.
          </p>
          <div>
            <p className="text-espresso font-medium mb-1">Titolare del Trattamento</p>
            <p>
              Ditta Individuale <span className="text-espresso font-medium">Alina Cossali</span>
              <br />
              P.IVA 04494520168 · C.F. CSSLNA86C56C800I
              <br />
              Sede: Via Pos Palì 2, 24020 Parre (BG)
              <br />
              Email:{" "}
              <a href="mailto:info@alinacossali.it" className="text-fuchsiabrand underline">
                info@alinacossali.it
              </a>
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Dati raccolti</p>
            <p>
              Tramite questo modulo: {dataFields}. Il sito raccoglie inoltre, tramite gli
              altri moduli presenti: dati del form di contatto (nome, email, telefono,
              città, messaggio, servizio di interesse); dati di iscrizione alla Masterclass
              (nome, cognome, email, città/zona, eventuale preferenza di disponibilità per
              la call diagnostica); dati dell'account Google per l'accesso all'area riservata
              (riservata alla titolare).
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Finalità del trattamento</p>
            <p>
              I dati sono trattati per: rispondere alle tue richieste di informazioni e
              ricontattarti; verificare la disponibilità e organizzare le consulenze
              d'immagine dal vivo; gestire l'iscrizione alla Masterclass, la prenotazione
              della Call Diagnostica e l'invio delle relative comunicazioni via email
              (conferme, link Zoom, promemoria); gestire la lista d'attesa; assolvere
              eventuali obblighi di legge, contabili e fiscali.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Base giuridica</p>
            <p>
              Il trattamento si basa sul tuo consenso e sull'esecuzione di misure
              precontrattuali e contrattuali richieste da te; per gli adempimenti fiscali e
              contabili, sull'obbligo legale.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Modalità e conservazione</p>
            <p>
              I dati sono conservati in modo sicuro e per il tempo strettamente necessario
              alle finalità indicate (e, per i dati fiscali, secondo i termini di legge).
              Non vengono ceduti a terzi né utilizzati per attività di marketing non
              richieste.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Servizi di terze parti</p>
            <p>
              Per l'erogazione del servizio il sito si appoggia a: provider di invio email
              transazionale; Google (accesso area riservata, Google Calendar); Zoom
              (dirette e call); WhatsApp e Instagram (link esterni). Questi soggetti
              trattano i dati secondo le proprie informative privacy, anche su server
              extra-UE nel rispetto delle garanzie previste dal GDPR.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Cookie</p>
            <p>
              Questo sito utilizza esclusivamente cookie e strumenti tecnici necessari al
              suo funzionamento: nessun cookie di profilazione o di analisi di terze parti.
              Dettagli nella Cookie Policy, linkata nel footer di ogni pagina.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">I tuoi diritti</p>
            <p>
              In qualsiasi momento puoi richiedere accesso, rettifica, cancellazione,
              limitazione del trattamento dei tuoi dati, oppure revocare il consenso,
              scrivendo a{" "}
              <a href="mailto:info@alinacossali.it" className="text-fuchsiabrand underline">
                info@alinacossali.it
              </a>
              . Hai inoltre diritto di proporre reclamo al Garante per la protezione dei
              dati personali (www.garanteprivacy.it).
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
